import React, { useState, useEffect } from "react";
import Authentication from "../../../api/Authentication/Authentication";
import API from "../../../api/API";

const MoveItemModal = ({ startDir, excludeFolder, onSave, onCancel }) => {
  const [currentDir, setCurrentDir] = useState(startDir); // starts at root
  const [prevDir, setPrevDir] = useState(null); // starts at root
  const [folderData, setFolderData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Function to load folders from the current directory.
  const loadFolders = () => {
    setLoading(true);
    API.getDirecotryInfo(      
      Authentication.getCurrentUser()?._id, 
      Authentication.getCurrentUser()?.token, 
      currentDir.id
    ).then((result) => {
        if (result.data.success) {
          // Filter to include only folders and exclude the one being moved.
          const folders = result.data.info.children.filter(
            (item) => item.type === "dir" && (item.id !== excludeFolder.id)
          );
          setPrevDir(result.data.info.parent);
          setFolderData(folders);
        } else {
          setError("Failed to load folders.");
        }
        setLoading(false);
      })
      .catch((err) => {
        setError("Error loading folders."+err);
        setLoading(false);
      });
  };

  // Load folders when currentDir changes.
  useEffect(() => {
    loadFolders();
    // We disable exhaustive-deps because we only want this to run once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDir]);

  // Navigate into a folder.
  const handleFolderClick = (folder) => {
    setCurrentDir(folder);
  };

  // Navigate back one level.
  const handleBack = () => {
    prevDir.id = prevDir.parent
    setCurrentDir(prevDir);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded shadow-lg w-96">
        <h2 className="text-xl dark:text-gray-200  font-bold mb-4">Move Item</h2>
        <p className="mb-2 text-sm text-gray-600">
          Current Path:{" "}
          {currentDir.name}
        </p>
        {loading ? (
          <p>Loading folders...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <div className="max-h-60 overflow-y-auto border p-2 mb-4">
            {folderData.length === 0 ? (
              <p className="text-gray-500 dark:text-gray-300 ">No folders available</p>
            ) : (
              folderData.map((folder) => (
                <div
                  key={folder.name}
                  className="p-2 cursor-pointer hover:bg-gray-200 rounded hover:dark:bg-gray-900  dark:text-gray-200 "
                  onClick={() => handleFolderClick(folder)}
                >
                  {folder.name}
                </div>
              ))
            )}
          </div>
        )}
        <div className="flex justify-between">
          <button
            onClick={handleBack}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            disabled={!currentDir.parent}
          >
            Back
          </button>
          <div>
            <button
              onClick={onCancel}
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 mr-2"
            >
              Cancel
            </button>
            <button
              onClick={() => onSave(currentDir)}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Select This Folder
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoveItemModal;